import { loadProductAvailabilityConfig } from '@loomstateorg/shared-frontend/components/product-availability/config';

// Function to initialize product availability configuration
// Call this once during app initialization (not a React hook)
export const initializeProductAvailabilityConfig = () => {
  // Only run on client side
  if (typeof window !== 'undefined') {
    loadProductAvailabilityConfig();
  }
};